<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<qw-input type="number"
			  :style="{'width': width}"
			  style="display: inline-block"
			  :formatDataInProp="formatDataInProp"
			  :formatDataOutProp="formatDataOutProp"
			  v-bind="$attrs"/>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {stringToNumber} from "@/utils/helpers";

export default {
	name: "QwInputNumber",
	methods: {stringToNumber},
	extends: BaseComponent,

	inheritAttrs: false,

	props: {
		width: {String, default: "80px"},
		formatDataInProp: Function,
		formatDataOutProp: Function,
	},
}
</script>

<style lang="scss">

</style>
